import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { t } from "./locale";
import { button, div } from "./van/van-tags";
import type { ViewComponent } from "./van/view-component";

class LoadingScreen implements ViewComponent {
	async waitFor<T>(p: Promise<T>): Promise<T> {
		if (this.#reactive.count < 0) {
			this.#reactive.count = 1;
		} else {
			this.#reactive.count++;
		}

		try {
			// Ensure that the loading screen is at least shown for 300 ms.
			// This acts as visual feedback for user actions.
			const minDelay = new Promise((resolve) => setTimeout(resolve, 300));
			await Promise.allSettled([p, minDelay]);
		} finally {
			this.#reactive.count--;
		}

		return p;
	}

	#reactive = reactive({
		count: 0,
	});

	ChildDom: ChildDom;

	constructor() {
		this.ChildDom = div(
			{
				class: () =>
					this.#reactive.count > 0 ? "modal is-active" : "modal",
			},
			div({ class: "modal-background" }),
			div(
				{ class: "modal-content" },
				div(
					{ class: "box" },
					div(
						{ class: "level" },
						div(
							{ class: "level-item" },
							button({
								class: "button is-white is-large is-loading",
								disabled: true,
							}),
							button(
								{
									class: "button is-danger",
									onclick: () => {
										this.#reactive.count = 0;
										window.history.back();
									},
								},
								() => t.cancel,
							),
						),
					),
				),
			),
		);
	}
}

export const loadingScreen = new LoadingScreen();
